import { Injectable, signal } from '@angular/core';
import { ToastMessageOptions, ToastOptions } from './toast.types';
import { DEFAULT_TOAST_OPTIONS } from './toast.constants';
import { AlertVariant } from '../alert/alert.component';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _message = signal<ToastMessageOptions | null>(null);

  /** @internal */
  public readonly message = this._message.asReadonly();

  public warning(message: string, options?: Partial<ToastOptions>): void {
    const toastMessage = this._setToastMessage(message, 'warning', options);
    this._message.set(toastMessage);
  }

  public error(message: string, options?: Partial<ToastOptions>): void {
    const toastMessage = this._setToastMessage(message, 'danger', options);
    this._message.set(toastMessage);
  }

  public success(message: string, options?: Partial<ToastOptions>): void {
    const toastMessage = this._setToastMessage(message, 'success', options);
    this._message.set(toastMessage);
  }

  public info(message: string, options?: Partial<ToastOptions>): void {
    const toastMessage = this._setToastMessage(message, 'info', options);
    this._message.set(toastMessage);
  }

  public primary(message: string, options?: Partial<ToastOptions>): void {
    const toastMessage = this._setToastMessage(message, 'primary', options);
    this._message.set(toastMessage);
  }

  public secondary(message: string, options?: Partial<ToastOptions>): void {
    const toastMessage = this._setToastMessage(message, 'secondary', options);
    this._message.set(toastMessage);
  }

  private _setToastMessage(
    message: string,
    variant: AlertVariant,
    options?: Partial<ToastOptions>,
  ): ToastMessageOptions {
    return {
      ...DEFAULT_TOAST_OPTIONS,
      ...options,
      id: crypto.randomUUID(),
      message,
      variant,
    };
  }
}
